 document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.bp-gt--slider-inner');
    const dots = document.querySelectorAll('#bp-gt--custom-dots li');

    if (!slider || !dots.length) return;

    dots.forEach(dot => {
        dot.addEventListener('click', function () {
            const index = parseInt(this.getAttribute('data-index'));
            const cards = slider.querySelectorAll('.bp-gt--peek-item');

            if (cards[index]) {
                cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
        });
    });

    slider.addEventListener('scroll', function () {
        let scrollPos = slider.scrollLeft;
        let cardWidth = slider.querySelector('.bp-gt--peek-item').offsetWidth + 15;

        let activeIndex = Math.round(scrollPos / cardWidth);

        dots.forEach((dot, index) => {
            if (index === activeIndex) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
    });

    const floatingBar = document.querySelector('.bp-gt--floating-bar');
    const purchaseSection = document.querySelector('.bp-gt--purchase');

    if (floatingBar && purchaseSection) {
        const barObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    floatingBar.classList.add('bp-gt--floating-hidden');
                } else {
                    floatingBar.classList.remove('bp-gt--floating-hidden');
                }
            });
        }, {
            threshold: 0.1 
        });

        barObserver.observe(purchaseSection);
    }


    const revealElements = document.querySelectorAll('.bp-gt--reveal-up');

    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('bp-gt--reveal-active');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15, // Triggers when 15% of the element is visible
        rootMargin: "0px 0px -50px 0px" 
    });
    revealElements.forEach(el => {
        revealObserver.observe(el);
    });

  const packCards = document.querySelectorAll('.bp-gt--pack-card');
    const checkoutButtons = document.querySelectorAll('.bp-gt--final-checkout-btn, .bp-gt--floating-btn');
    
    // Floating bar elements
    const floatTitle = document.querySelector('.bp-gt--floating-title');
    const floatPrice = document.querySelector('.bp-gt--floating-price-current');
    const floatStrike = document.querySelector('.bp-gt--floating-price-strike');
    const floatBadge = document.querySelector('.bp-gt--floating-save-badge');
    
    let selectedVariantId = null;
    let selectedSellingPlanId = null; 
    let upsellVariantId = null;

    function setSelection(card) {
      if (!card) return;
      
      selectedVariantId = card.getAttribute('data-variant-id');
      selectedSellingPlanId = null; 
      
      packCards.forEach(c => c.classList.remove('bp-gt--pack-card-active'));
      card.classList.add('bp-gt--pack-card-active');

      const activeOption = card.querySelector('.bp-gt--option-active');
      let priceText = card.querySelector('.bp-gt--price-current')?.innerText || "";
      let percentText = "";
      let stickerText = "";
      let perPackText = ""; 

      const savePill = card.querySelector('.bp-gt--save-pill');
      if (savePill) {
          const matchPercent = savePill.innerText.match(/Save\s*(\d+)%/i);
          if (matchPercent) percentText = matchPercent[1];
      }
      
      // Auto-detect V1 vs V2 formats
      const stickerEl = card.querySelector('.bp-gt--price-sticker');
      if (stickerEl) {
          stickerText = stickerEl.innerText.replace(' per sticker', '').replace('/sticker', '').replace('Only ', '').trim();
      }

      const unitEl = card.querySelector('.bp-gt--price-unit');
      let isV1UnitFormat = false;
      if (unitEl) {
          isV1UnitFormat = unitEl.innerText.toLowerCase().includes('each');
          perPackText = unitEl.innerText.replace(/ per pack| each/gi, '').trim();
      }

      if (activeOption) {
          if (activeOption.getAttribute('data-type') === 'subscribe') {
              selectedSellingPlanId = activeOption.getAttribute('data-plan-id');
          }

          if (activeOption.getAttribute('data-price')) priceText = activeOption.getAttribute('data-price');
          if (activeOption.getAttribute('data-percent')) percentText = activeOption.getAttribute('data-percent');
          if (activeOption.getAttribute('data-sticker')) stickerText = activeOption.getAttribute('data-sticker');
          if (activeOption.getAttribute('data-per-pack')) perPackText = activeOption.getAttribute('data-per-pack'); 
      }

      const cardPriceEl = card.querySelector('.bp-gt--price-current');
      if (cardPriceEl) cardPriceEl.innerText = priceText;

      //  (V2 only)
      if (stickerEl && stickerText) {
          stickerEl.innerText = stickerText + " per sticker";
      }

      // Update unit format dynamically based on V1 ("each") vs V2 ("per pack")
      if (unitEl && perPackText) {
          unitEl.innerText = perPackText + (isV1UnitFormat ? " each" : " per pack"); 
      }

      if (savePill && percentText) {
          const pillTextLower = savePill.innerText.toLowerCase();
          
          if (pillTextLower.includes('each')) {
              savePill.innerText = `Save ${percentText}% · ${perPackText} each`;
          } else if (pillTextLower.includes('sticker')) {
              savePill.innerText = `Save ${percentText}% · Only ${stickerText}/sticker`;
          } else {
              savePill.innerText = `Save ${percentText}%`;
          }
      }
      
      if (floatTitle && floatPrice) {
        
        let baseTitle = card.querySelector('.bp-gt--pack-title')?.innerText || "";
        let packDesc = "";
        const descEl = card.querySelector('.bp-gt--pack-desc');
        
        if (descEl) {
            packDesc = descEl.innerText.split('·')[0].trim();
        }
        
        floatTitle.innerText = packDesc && packDesc !== baseTitle ? `${baseTitle} (${packDesc})` : baseTitle;
        
        floatPrice.innerText = priceText; 
        
        const strikeEl = card.querySelector('.bp-gt--price-strike');
        
        if (strikeEl && floatStrike) {
           floatStrike.innerText = strikeEl.innerText;
           floatStrike.style.display = 'inline';
        } else if (floatStrike) {
           floatStrike.style.display = 'none';
        }

        if (floatBadge && percentText) {
           // Auto-Detect V1 vs V2 Floating Bar
           const isV1Floating = floatBadge.parentElement.classList.contains('bp-gt--floating-pricing');
           
           if (isV1Floating) {
               floatBadge.innerText = `Save ${percentText}%`;
           } else {
               floatBadge.innerText = `Save ${percentText}% · ${stickerText}/sticker`;
           }
           floatBadge.style.display = 'inline-block';
        } else if (floatBadge) {
           floatBadge.style.display = 'none';
        }
      }
    }

    const optionBoxes = document.querySelectorAll('.bp-gt--option-box');
    optionBoxes.forEach(box => {
        box.addEventListener('click', function(e) {
            e.stopPropagation(); 
            
            const parentCard = this.closest('.bp-gt--pack-card');
            
            const siblingOptions = parentCard.querySelectorAll('.bp-gt--option-box');
            siblingOptions.forEach(opt => opt.classList.remove('bp-gt--option-active'));
            this.classList.add('bp-gt--option-active');
            
            setSelection(parentCard);
        });
    });

    packCards.forEach(card => {
      card.addEventListener('click', function() {
        setSelection(this);
      });
    });

    const defaultCard = document.querySelector('.bp-gt--pack-card-active') || packCards[1] || packCards[0]; 
    if (defaultCard) setSelection(defaultCard);

    const upsellBtn = document.querySelector('.bp-gt--upsell-btn');
    if (upsellBtn) {
        upsellBtn.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Grab the variant ID from the button
            upsellVariantId = this.getAttribute('data-variant-id');
            
            // Change the visuals to disabled/added
            this.innerText = "Added to Order ✓";
            this.classList.add('bp-gt--upsell-added');
        });
    }

    checkoutButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); 
        
        if (selectedVariantId) {
            const originalText = this.innerText;
            this.innerText = "Processing...";

            let formData = { 'items': [{ 'id': selectedVariantId, 'quantity': 1 }] };

            if (selectedSellingPlanId) {
                formData.items[0].selling_plan = selectedSellingPlanId;
            }

            if (upsellVariantId) {
                formData.items.push({ 'id': upsellVariantId, 'quantity': 1 });
            }

            fetch('/cart/clear.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(() => {
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
            })
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
                this.innerText = originalText; 
                alert('Something went wrong. Please try again.');
            });

        } else {
          alert('Please select a pack first.');
        }
      });
    });

    // --- COUNTDOWN TIMER  ---
    const timerElement = document.getElementById('bp-gt--timer');

    if (timerElement) {
        const minSeconds = 15 * 60; 
        const maxSeconds = 20 * 60; 

        let totalSeconds = Math.floor(Math.random() * (maxSeconds - minSeconds + 1)) + minSeconds;

        const countdownInterval = setInterval(function() {
            let minutes = Math.floor(totalSeconds / 60);
            let seconds = totalSeconds % 60;

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            timerElement.innerText = minutes + ":" + seconds;

            if (totalSeconds <= 0) {
                clearInterval(countdownInterval);
                
                const countdownBar = timerElement.closest('.bp-gt--countdown-bar');
                if (countdownBar) {
                    countdownBar.style.display = 'none';
                }
                
            } else {
                totalSeconds--;
            }
        }, 1000); 
    }

});